import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Inbox, CalendarDays, Clock, Settings, LogOut, ExternalLink, CreditCard, Link2, Tags } from "lucide-react";
import { Logo } from "../components/site/Logo";
import { useAuth } from "./AuthContext";

const LINKS = [
  ["/admin", "Tableau de bord", LayoutDashboard, "dashboard"],
  ["/admin/demandes", "Demandes", Inbox, "leads"],
  ["/admin/rdv", "Rendez-vous", CalendarDays, "appointments"],
  ["/admin/creneaux", "Créneaux", Clock, "slots"],
  ["/admin/paiements", "Paiements", CreditCard, "payments"],
  ["/admin/liens", "Liens de paiement", Link2, "links"],
  ["/admin/forfaits", "Forfaits", Tags, "forfaits"],
  ["/admin/parametres", "Paramètres", Settings, "settings"],
];

export const STATUS_COLORS = {
  nouveau: "bg-blue-100 text-blue-900", "en cours": "bg-amber-100 text-amber-900", "devis envoyé": "bg-violet-100 text-violet-900",
  gagné: "bg-green-100 text-green-900", perdu: "bg-slate-200 text-slate-800", confirmé: "bg-green-100 text-green-900", annulé: "bg-slate-200 text-slate-700",
};
export const LEAD_STATUSES = ["nouveau", "en cours", "devis envoyé", "gagné", "perdu"];
export const fmtDateTime = (iso) => new Date(iso).toLocaleString("fr-FR", { dateStyle: "medium", timeStyle: "short", timeZone: "Europe/Paris" });

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-slate-50 lg:grid lg:grid-cols-[260px,1fr]" data-testid="admin-layout">
      <aside className="bg-white border-b lg:border-b-0 lg:border-r border-slate-200 p-5 lg:min-h-screen lg:sticky lg:top-0">
        <Logo testid="admin-logo" />
        <nav className="mt-6 flex lg:flex-col gap-1 overflow-x-auto" aria-label="Navigation admin">
          {LINKS.map(([to, label, Icon, id]) => (
            <NavLink key={to} to={to} end={to === "/admin"} data-testid={`admin-nav-${id}`}
              className={({ isActive }) => `flex items-center gap-3 rounded-xl px-3 py-2.5 font-semibold whitespace-nowrap transition-colors ${isActive ? "bg-navy text-white" : "text-navy hover:bg-mist"}`}>
              <Icon className="h-5 w-5" aria-hidden="true" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-6 lg:mt-10 pt-6 border-t border-slate-200 space-y-2 text-sm">
          <p className="text-slate-600 truncate" data-testid="admin-user-email">{user?.email}</p>
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-navy font-semibold"><ExternalLink className="h-4 w-4" aria-hidden="true" /> Voir le site</a>
          <button type="button" onClick={logout} className="flex items-center gap-2 text-brand-ink font-semibold" data-testid="admin-logout"><LogOut className="h-4 w-4" aria-hidden="true" /> Se déconnecter</button>
        </div>
      </aside>
      <main className="p-5 sm:p-8 lg:p-10 min-w-0"><Outlet /></main>
    </div>
  );
}
